import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Grid, Box, Card } from '@material-ui/core';
import { Author, AvatarGroupIdea } from '../../Shared';
import { IdeaCss } from '../IdeaCss';
import { useIdeaDetailsController } from '../../../containers/IdeaDetailsPage/hooks/useIdeaDetailsController';

export function IdeaInfo() {
  const classes = IdeaCss();
  const { t } = useTranslation();
  const { hasIdeaFlux, stepflux } = useIdeaDetailsController();

  return (
    <>
      <Grid item xs={12}>
        <Typography className={classes.titleUpperCase}>{t('ideia_geral')}</Typography>
      </Grid>
      <Grid item xs={12} sm={8} md={8} lg={8}>
        <Card elevation={0} className={classes.card} style={{ height: '100%' }}>
          <Grid container spacing={2} className={classes.ideaGeneralField} >
            <Grid item xs={12} style={{ marginLeft: -16, marginTop: -16 }}>
              {hasIdeaFlux.contributors.length > 0 ? (
                <AvatarGroupIdea user={hasIdeaFlux.user} idea={hasIdeaFlux} />
              ) : (
                <Author
                  activeUser={hasIdeaFlux.user?.status}
                  isTimeline={true}
                  userAuthor={hasIdeaFlux.user}
                  timelineDate={hasIdeaFlux.timelineDate}
                />
              )}
            </Grid>
            
            {hasIdeaFlux?.cardThumbnail?.url && (
              <Grid item xs={12}>
                <img src={hasIdeaFlux?.cardThumbnail?.url} alt="thumbnail" style={{ width: 300 }} />
              </Grid>
            )}

            <Grid item xs={12}>
              <Typography variant="subtitle2">{hasIdeaFlux.name}</Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" style={{ wordWrap: 'break-word' }}>
                {hasIdeaFlux.description}
              </Typography>
            </Grid>

            {stepflux && hasIdeaFlux?.problem && (
              <Grid item xs={12}>
                <Typography variant="subtitle2" gutterBottom>
                  {t('problema_identificado')}
                </Typography>
                <Typography variant="body2"  style={{ wordWrap: 'break-word' }}>
                  {hasIdeaFlux?.problem}
                </Typography>
              </Grid>           
            )}

            {stepflux && hasIdeaFlux?.solution && (
              <Grid item xs={12}>
                <Typography variant="subtitle2" gutterBottom>
                  {t('solucao_proposta')}
                </Typography>
                <Typography variant="body2">
                  {hasIdeaFlux?.solution}
                </Typography>
              </Grid>
            )}

            <Grid item xs={12}>
              {hasIdeaFlux?.innovationQuestions?.map((item) => (
                <Box key={item._id}>
                  <Box marginBottom="1.2rem">
                    <Typography variant="subtitle2" gutterBottom>{item.question}</Typography>
                    {item?.answer.length > 0 && <Typography variant="body2">{item.answer}</Typography>}
                  </Box>
                  {(item.attachmentRequired && hasIdeaFlux?.attachmentQuestionOne?.url) && (
                    <img
                      className={classes.attachment}
                      src={hasIdeaFlux?.attachmentQuestionOne?.url}
                      alt={hasIdeaFlux?.attachmentQuestionOne?.fileName}
                    />
                  )}
                  {(item.attachmentRequired && hasIdeaFlux?.attachmentQuestionTwo?.url) && (
                    <img
                      className={classes.attachment}
                      src={hasIdeaFlux?.attachmentQuestionTwo?.url}
                      alt={hasIdeaFlux?.attachmentQuestionTwo?.fileName}
                    />
                  )}
                </Box>
              ))}
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </>
  );
}
